<template>
	<el-card v-show="exercise.length > 0 || yoga.length > 0 || mindfulness.length > 0">
		<div slot="header" class="exercise header">
			<img src="../image/exercise_new.png" class="header-icon">
			<span class="header-title">Activities</span>
		</div>
		<ActivityTable :patient="patient"
			v-bind:exercise="exercise"
			v-bind:yoga="yoga"
			v-bind:mindfulness="mindfulness">
		</ActivityTable>
	</el-card>
</template>

<script>
import OverviewCard from '..'
import ActivityTable from './Table'

export default {
	name: 'patient-activity-card',
	extends: OverviewCard,

	computed: {
		exercise() {
			return this.patientEventType('exercise')
		},
		yoga() {
			return this.patientEventType('yoga')
		},
		mindfulness() {
			return this.patientEventType('mindfulness')
		}
	},

	components: {
		ActivityTable
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
